import React from 'react';
import PropTypes from 'prop-types';
import Notification from '~/components/Notification';
import {Button} from '@customink/pigment-react';

/** @param {PropTypes.InferProps<typeof propTypes>} props - Component properties. */
export default function ExitConfirmation(props) {
  const navHome = () => (window.location.href = window.location.origin);

  return (
    <Notification
      dismiss={props.dismiss}
      title={'Are you sure you want to leave?'}
      type="ERROR">
      <br />
      <p className="ndx-cta1">
        Your design progress will be lost. <br /> Return to the design lab to
        save <br />
        before you leave.
      </p>
      <Button
        size="large"
        variant="Primary"
        className="notification-cta"
        onClick={navHome}>
        Leave Without Saving
      </Button>
      <Button
        size="large"
        variant="secondary"
        className="notification-cta"
        onClick={props.dismiss}>
        Return to the Design Lab
      </Button>
    </Notification>
  );
}

const propTypes = {
  dismiss: PropTypes.func
};

ExitConfirmation.propTypes = propTypes;

ExitConfirmation.displayName = 'ExitConfirmation';
